import { AssetAvailableScheduleItems } from "slot-definitions"
import { ScheduleOptions } from "routes/asset-register/plugins/schedule-options/schedule-options"

AssetAvailableScheduleItems.plug(<ScheduleOptions />)
